import { ICourseModule } from '@/shared/ICourseModule'
import { naturalComparer } from '@/shared/parse'
import { Button, VStack, Collapse, HStack } from '@chakra-ui/react'
import React from 'react'
import { FiChevronDown, FiChevronRight } from 'react-icons/fi'
import { ICourse } from '@/shared/ICourse'
import { IFile } from '@/shared/IFile'
import { CourseStepFileGroup } from './CourseStepFileGroup'

export const CourseStepFileList = (props: {
  label: string,
  isExpanded?: boolean,
  showDates?: boolean,
  course: ICourse | undefined,
  module: ICourseModule | undefined
}) => {

  const isSpecialFile = (file: IFile) => {
    if (props.course && props.module && props.course.folderName) {
      const escapedFolderName = props.course.folderName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return new RegExp(`${escapedFolderName}.*\.pdf`, 'i').test(file.name);
    }
  }
  const sort = (a: IFile, b: IFile) => {
    if (isSpecialFile(a) && !isSpecialFile(b)) return -1;
    if (!isSpecialFile(a) && isSpecialFile(b)) return +1;
    return naturalComparer.compare(a.title || a.name, b.title || b.name)
  }

  const allFiles = props.module?.files?.sort(sort) ?? [];

  // Exclude "system" files (like _results.json)
  const files = allFiles?.filter(x => !/^_.*.json$/i.test(x.name)) ?? [];

  // Include only "system" files (like _backup***.pdf)
  const actualFiles = files?.filter(x => !x.name.startsWith('_backup')) ?? [];
  const historicalFiles = files?.filter(x => x.name.startsWith('_backup')) ?? [];

  const [isExpanded, setIsExpanded] = React.useState(props.isExpanded);
  const [historicalFilesExpanded, setHistoricalFilesExpanded] = React.useState(false);

  return (
    <Collapse in={files.length > 0}>
      <VStack mt='4' align='start'>
        <HStack>
          <Button variant='ghost' colorScheme='gray' 
            leftIcon={isExpanded ? <FiChevronDown /> : <FiChevronRight />} 
            onClick={() => setIsExpanded(!isExpanded)} aria-label={''}>{`${props.label} (${actualFiles.length})`}</Button>
          {historicalFiles.length > 0 && 
            <Button variant='ghost' colorScheme='gray' 
              leftIcon={historicalFilesExpanded ? <FiChevronDown /> : <FiChevronRight />} 
              onClick={() => setHistoricalFilesExpanded(!historicalFilesExpanded)} aria-label={''}>{`${props.label} - Historical (${historicalFiles.length})`}</Button>
          }
        </HStack>
        <Collapse in={isExpanded} animateOpacity>
          <VStack ml='4' spacing="4" align='start'>
            <CourseStepFileGroup files={actualFiles} isSpecialFile={isSpecialFile} />
          </VStack>
        </Collapse>
        <Collapse in={historicalFilesExpanded} animateOpacity>
          <VStack ml='4' spacing="4" align='start'>
            <CourseStepFileGroup files={historicalFiles} isSpecialFile={isSpecialFile} />
          </VStack>
        </Collapse>
      </VStack>
    </Collapse>
  )
}